export var ANALYTICS_CHANNEL = 'media';
export var DATASOURCE_DEFAULT_LAYOUT = 'wide';